export default __webpack_public_path__ + "static/media/Cards.d08beaf6.svg";